export default "__VITE_ASSET__a73e474d__"